// Chọn giao diện Hệ thống / Sáng / Tối (menu tài khoản, màn đăng nhập). Lưu theo trình duyệt: useTheme (shared/lib/theme).
// Nhóm radio đúng mẫu WAI-ARIA: một điểm Tab (nút đang chọn), ←/→ (↑/↓) đổi lựa chọn và chuyển tiêu điểm.
import { useRef, type KeyboardEvent } from 'react';
import { cx } from '../lib/cx';
import { useTheme, type ThemeChoice } from '../lib/theme';

const OPTIONS: [ThemeChoice, string, string][] = [
  ['system', 'Hệ thống', 'Theo cài đặt sáng/tối của máy'],
  ['light', 'Sáng', 'Luôn dùng giao diện sáng'],
  ['dark', 'Tối', 'Luôn dùng giao diện tối'],
];

export function ThemeSwitch({ className }: { className?: string }) {
  const { choice, setChoice } = useTheme();
  const ref = useRef<HTMLDivElement>(null);
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    const step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
    if (!step) return;
    e.preventDefault();
    const i = (OPTIONS.findIndex(([k]) => k === choice) + step + OPTIONS.length) % OPTIONS.length;
    setChoice(OPTIONS[i]![0]);
    ref.current?.querySelectorAll<HTMLButtonElement>('[role="radio"]')[i]?.focus();
  };
  return (
    <div ref={ref} className={cx('seg sm theme-switch', className)} role="radiogroup" aria-label="Giao diện" onKeyDown={onKeyDown}>
      {OPTIONS.map(([k, label, title]) => (
        <button key={k} type="button" role="radio" aria-checked={choice === k} tabIndex={choice === k ? 0 : -1} title={title} className={choice === k ? 'on' : ''} onClick={() => setChoice(k)}>
          {label}
        </button>
      ))}
    </div>
  );
}
